import { PayloadAction } from "@reduxjs/toolkit";

import { MapState } from "../../types";

export const setFocusPoint = (
  state: MapState,
  action: PayloadAction<MapState['focusPoint']>
) => {
  state.focusPoint = action.payload;
}